import { irwin } from 'config'
import Jsona, { SwitchCaseJsonMapper } from 'jsona'
import { httpClient } from './httpClient'
import axios from 'axios'
import { toSnake } from 'change-object-case'

const switchCaseOptions = {
  switchChar: '_',
}
const deserializer = new Jsona({
  jsonPropertiesMapper: new SwitchCaseJsonMapper(switchCaseOptions),
})

function client() {
  return httpClient(irwin.baseUrl)
}

let searchRequestAbortController

async function searchSecurities(term = '') {
  const params = { term }

  if (searchRequestAbortController) {
    searchRequestAbortController.abort('Operation cancelled by the user.')
  }

  try {
    searchRequestAbortController = new AbortController()
    const response = await client().get('v2/securities/search', {
      params,
      signal: searchRequestAbortController.signal,
    })
    return deserializer.deserialize(response)
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log('Request cancelled', error.message)
      return []
    }

    throw error // propagate error if not a cancelled request
  }
}

async function fetchSecurities(ids = [], params) {
  const response = await client().get(`v2/securities`, { params: { ids, ...toSnake(params) } })
  return {
    data: deserializer.deserialize(response),
    meta: response.meta,
  }
}

async function fetchSecurityById(id, params) {
  const response = await client().get(`v2/securities/${id}`, { params: { ...params } })
  return deserializer.deserialize(response)
}

async function saveOverride({ sectorCode, subsectorCode, entityId, hasOverride }) {
  const payload = {
    factset_entity_id: entityId,
    pics_sector_code: sectorCode,
    pics_subsector_code: subsectorCode,
  }

  if (hasOverride) {
    const response = await client().patch(`v2/ds1/sector_overrides/${entityId}`, payload)
    return deserializer.deserialize(response)
  } else {
    const response = await client().post('v2/ds1/sector_overrides', payload)
    return deserializer.deserialize(response)
  }
}

async function deleteOverride({ issuerLegacyId }) {
  return await client().delete(`v2/ds1/sector_overrides/${issuerLegacyId}`)
}

async function search(params) {
  const pagination = params.page_size !== undefined && params.page_offset !== undefined

  if (searchRequestAbortController) {
    searchRequestAbortController.abort('Operation cancelled by the user.')
  }

  try {
    searchRequestAbortController = new AbortController()
    const response = await client().get('/v2/securities/search', {
      params,
      signal: searchRequestAbortController.signal,
    })

    return {
      data: deserializer.deserialize(response),
      ...(pagination && {
        links: response.links,
        count: response.meta.total,
      }),
    }
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log('Request cancelled', error.message)
      return {}
    }

    throw error
  }
}

export {
  search,
  searchSecurities,
  fetchSecurities,
  fetchSecurityById,
  saveOverride,
  deleteOverride,
}
